export enum OrgUnitType {
  RootOrgUnit = 'Root Organizational Unit',
  HeadOffice = 'Head Office',
  Branch = 'Branch',
}
